export default __webpack_public_path__ + "static/media/3_center.ac931be5.png";